import type { IMasterDataReasonCodeMappingRepository } from "@src/domain/repositories/masterData";
import type { DeleteMasterDataReasonCodeMappingsDTO } from "@src/domain/dto/masterData";

export class DeleteMasterDataReasonCodeMappingsUseCase {
  private readonly repository: IMasterDataReasonCodeMappingRepository;

  constructor(repository: IMasterDataReasonCodeMappingRepository) {
    this.repository = repository;
  }

  execute(params: DeleteMasterDataReasonCodeMappingsDTO) {
    return this.repository.deleteReasonCodeMappings(params);
  }
}
